export const RiskConstants = {
  StateKeys: {
    RiskTypes: "risks:types",
    CalendarSources: "risks:calendar-sources",
    AccessSubscriptions: "risks:access-subs",
  },
};
